import { environment } from '../../../../../../environments/environment';
import {
    Zone,
    Shipping
} from '../../../../../core';
  
const user = JSON.parse(localStorage.getItem(environment.sessionAuth));
const currency = user ? user.user.currencyCode : '';
const textCurrency = `Precio /${currency}`;
export const DESPACHO_DOMICILIO = 'despachoDomicilio';

  export const shipping = {
    searchText: 'Buscar zonas',
    addText: 'Agregar flete',
    export: false,
    filter: true,
    filterDefault: '1944659',
    checkbox: false,
    checkboxIds: 'zoneId',
    disabled: true,
    table: true,
    columns: [
      {
        title: 'Código',
        name: 'zoneId',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Zone) => element.zoneId
      },
      {
        title: 'Nombre',
        name: 'name',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Zone) => element.name
      },
      {
        title: 'Tipo',
        name: 'zoneTypeDescription',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Zone) => element.zoneTypeDescription
      },
      {
        title: 'Provincia/Cantones',
        name: 'provinceName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Zone) => element.provinceName
      },
      {
        title: 'Estado',
        name: 'active',
        type: 'boolean',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Zone) => element.active
      }
    ],
    subTable: {
      description: 'Lista de fletes asociados a ',
      columns: [
        {
          title: 'Descripción',
          name: 'description',
          type: 'string',
          editable: false,
          checkAll: false,
          class: 'left',
          value: (element: Shipping) => element.description
        },
        {
          title: 'Tipo de despacho',
          name: 'dispatchTypeName',
          type: 'string',
          editable: false,
          checkAll: false,
          class: 'right',
          value: (element: Shipping) => element.dispatchTypeName
        },
        {
          title: 'Medida',
          name: 'rule',
          type: 'string',
          editable: false,
          checkAll: false,
          class: 'right',
          value: (element: Shipping) => {
            if (element.rule !== 'PER_WEIGHT_RULE') {
              return 'Unidad';
            } else {
              return 'Peso';
            }
          }
        },
        {
          title: textCurrency,
          name: 'costs',
          type: 'string',
          editable: false,
          checkAll: false,
          class: 'right',
          value: (element: Shipping) => {
            if (element.rule !== 'PER_WEIGHT_RULE') {
              return Number(element.costs[0].amount).toFixed(2);
            } else {
              return element.costs.map(item => item.amount).join('/');
            }
          }
        },
        {
          title: 'Productos',
          name: 'view',
          type: 'button',
          editable: false,
          checkAll: false,
          class: 'center',
          value: (element: Shipping) => {
            return {
              data: element.id,
              icon: 'low_priority',
              tooltip: 'Ver más',
              class: 'recordColumn icon-table'
            };
          }
        },
        {
          title: 'Eliminar',
          name: 'delete',
          type: 'button',
          editable: false,
          checkAll: false,
          class: 'center',
          value: (element: Shipping) => {
            return {
              data: element.id,
              icon: 'delete',
              tooltip: 'Eliminar',
              class: ' recordColumn icon-table'
            };
          }
        }
      ]
    }
  };
